export const ADDRESS_TYPE = {
  TWO_LEVEL: "two_level",
  THREE_LEVEL: "three_level",
};
